export const transformPhoneNumber = (phone: string): string =>
  phone.charAt(0) === '+' ? phone : `+${phone}`;
